
import qs from "qs";
import {Toast} from "vant";
import codeKey from "@/components/Vsidentify.vue";
import CryptoJS from 'crypto-js'

import {vBeforeClose} from "@/utils/tool";
function encrypt(data) {
  var key = '79697368656e67746563686e6f6c6f6779636f6d70616e793230313930343131'
  key = CryptoJS.enc.Hex.parse(key)
  let iv = CryptoJS.enc.Hex.parse('79697368656e67746563684032303139')
  var enc = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  var enced = enc.ciphertext.toString()
  return enced
}
export default {
  components: {codeKey},
  data() {
    return {
      keycodeLogin:'',
      identifyCode:'',
      input: "",
      error: '',
      userName: '',
      newpass:"",
      conpass:"",
      showPassword: false, // 控制密码可见性的布尔变量
      showPassword2:false,
      passwordFieldType: 'password', // 密码输入框的类型
      passwordFieldType2: 'password', // 密码输入框的类型
      topTitle: this.$t('append_field.login'),
      show: true,
      isPassVerify: false,
      passBindPhone: "",
      uuid: "",
      uuidCode: "",
      uuidCodeText: this.$t('append_field.verification_code'),
      getCodeing: false,
      platformType:1,
      type: 1,
      showButton: true,
      passBind: '',
      rememberMe:false,
      diaTitle:[this.$t('append_field.sms_verification'),this.$t('append_field.email_verification')],
      newUuid:'',

    }
  },
  created() {
    this.Flush()
    try {
      const { username,phone,email} = this.$route.query
      this.userName = username
      this.passBind = email
      this.email = email
      this.passBindPhone= phone
    }catch (e) {
      console.log(e)
    }
  },
  methods: {
    vBeforeClose,
    //获取uuid
    setUuid(newUuid) {
      this.newUuid = newUuid
    },
    Flush() {
      this.identifyCode = ''
      for (let i = 0; i < 4; i++) {
        this.identifyCode += parseInt(Math.random() * 10)
      }
    },
    /*弹框*/
    close(){
      this.isPassVerify=false
      this.uuidCode=""
    },
    uuidLogin() {
      if(this.uuidCode==''){
        Toast(this.$t('append_field.get_code'),'fail')
      }
      this.$ajax({
        url: '/etv/updateForgetPassword.json',
        method: 'post',
        cache: false,
        params: {
          'code': this.uuidCode,
          'password': encrypt(this.newpass),
          'account': encrypt(this.userName),
          'verifyType': this.type,
        }
      }).then(res => {

        let code = res.data.code
        let msg = res.data.msg
        if (code === 0) {
          Toast(msg)
          this.$router.push({path:'/login'})
          localStorage.clear()
          //this.isPassVerify=false
        }else{
          this.isPassVerify=true
          Toast(msg,'fail')
        }
      })
    },
    selectedOption(option) {
      this.type = option
      //let verifyFlag= this.verifyFlag
      this.showButton = true
      if (this.type === 0) {
        this.passBind = this.passBindPhone
      } else {
        this.passBind = this.email
      }
    },
    //获取验证码
    getUuidCode() {

      this.$ajax.post('/etv/getVerifyCode.json',
          qs.stringify({
            account: this.userName,
            verifyType: this.type,
            verifyCode: this.keycodeLogin,
            uuid: this.newUuid
          })
      ).then(res => {
        if (res.data.code === 0) {
          if (this.getCodeing) {
            return
          }
          this.getCodeing = true
          let i = 60
          this.uuidCodeText = `${i}`+'s'
          let timer = setInterval(() => {
            i--
            this.uuidCodeText = `${i}`+'s'
            if (i === 0) {
              this.getCodeing = false
              timer && clearInterval(timer)
              this.uuidCodeText = this.$t('append_field.verification_code')
            }
          }, 1000)
          Toast(res.data.msg)
        } else {
          this.$refs.codeKey.getCode()
          Toast(res.data.msg,'fail')
        }
      })
    },
    /*弹框end*/
    onSubmit() {
      this.error = ""
      const reg = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[@#$%^&+=]).{8,}$/
      if (!reg.test(this.newpass)) {
        this.error = `(${this.$t('append_field.please_enter_password')})`
        return
      }
      if(this.newpass !== this.conpass){
        this.error = `(${this.$t('append_field.passwords_do_not_match')})`
        return
      }
      if(!this.userName){
        this.error = this.$t('append_field.username_not_exist')
        return
      }
      if(!this.keycodeLogin){
        Toast(this.$t('append_field.fill_code'),'fail')
        return;
      }
      this.isPassVerify = true
      if (this.email === '') {
        this.type=0
        this.passBind=this.passBindPhone
        this.showButton=false
      } else if(this.passBindPhone === ''){
        this.type=1
        this.passBind=this.email
        this.showButton=false
      }
    },
    togglePassword(num){
      if(num === 1){
        // 切换密码的可见性
        this.showPassword = !this.showPassword
        // 根据密码的可见性状态切换输入框的类型
        this.passwordFieldType = this.showPassword ? 'text' : 'password'
      }else{
        // 切换密码的可见性
        this.showPassword2 = !this.showPassword2
        // 根据密码的可见性状态切换输入框的类型
        this.passwordFieldType2 = this.showPassword2 ? 'text' : 'password'
      }
    },
    back() {
      this.$router.back()
    }
  }
}
